// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: white;
  text-shadow: 0 0 0.25px currentcolor; }

:where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-ink-bar {
  position: absolute;
  background: white;
  pointer-events: none; }

.ant-input-group-wrapper {
  border-radius: 7px !important;
  border: none !important;
  box-shadow: 0px 0px 0px #717272 !important; }

.ant-input-search-button {
  border: none; }
`, "",{"version":3,"sources":["webpack://./src/components/TabView.js/index.scss"],"names":[],"mappings":"AAKI;EACI,YAAW;EACX,oCAAoC,EAAA;;AAIxC;EACI,kBAAkB;EAClB,iBAAgB;EAChB,oBAAoB,EAAA;;AAExB;EACI,6BAA6B;EAC7B,uBAAuB;EAC1B,0CAA0C,EAAA;;AAE3C;EACI,YAAW,EAAA","sourcesContent":["// .ant-tabs-tab-btn{\r\n//     color:white !important;\r\n// }\r\n// .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\r\n//     color:white !important;}\r\n    :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\r\n        color:white;\r\n        text-shadow: 0 0 0.25px currentcolor;\r\n    }\r\n    \r\n    \r\n    :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-ink-bar {\r\n        position: absolute;\r\n        background:white;\r\n        pointer-events: none;\r\n    }\r\n    .ant-input-group-wrapper {\r\n        border-radius: 7px !important;\r\n        border: none !important;\r\n     box-shadow: 0px 0px 0px #717272 !important;\r\n    }\r\n    .ant-input-search-button{\r\n        border:none;\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
